
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getAvoidLoginUrl, getWhiteSign } from "@/api/iousServices";
import { openFDWhitePage } from '@/utils/h5ToApp'
import dayjs from "dayjs"

@Component({
  name: 'AuthorizeConfirm',
  components: {}
})
export default class AuthorizeConfirm extends Vue {
  @Getter whiteStrips!: string
  @Getter companyId: string
  @Getter mobile!: string

  financeFlag = window.localStorage.getItem('isFinance')
  whiteSignTime = ''
  endSignTime = ''

  created() {
    this.financeFlag = window.localStorage.getItem('isFinance')
  }

  goPay() {
    if(this.financeFlag) {
      this.$goHomeBack()
    }else {
      this.$router.push({
          path:'/iousServices',
          query:{
            fromPage:'认证通过'
          }
        })
    }

  }
  goPurchase() {
    console.log('purchasefinanceFlag=',this.financeFlag);
    if (this.financeFlag) {
      this.$router.push('/homes')
    } else {
      // 从白条来跳转全部订单页面
      let FDWhite = window.localStorage.getItem('FDWhite')
      // console.log('FDWhite-----', FDWhite)
      if (FDWhite) {
        this.$router.push({
          path: '/orderMall',
          query: {
            orderName: '全部订单',
            from: 'authorizeConfirm'
          }
        })
      } else {
        this.$router.back()
      }
    }
  }
  goHome() {
    this.$router.push({
      path: '/shopMallOrder',
      query: {
        isHome:'home'
      }
    })
    // this.$goHomeBack()
  }
  // 1还款入口 2授信入口 3借款入口
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        let encodeUrl = encodeURI(data.responseData.redirectUrl)
        let isQuery = encodeUrl.indexOf('?') > -1
        let url = `${encodeUrl}${isQuery? '&' : '?'}webShow=${flag}&userPhone=${this.mobile}`
        openFDWhitePage({url})
        console.log('getAvoidLoginUrl=',url);
      }
    }).catch(() => {
      this.$toast('此产业商城暂未开通白条快付')
    })
  }

  // 获取授权书记录
  getSign() {
    getWhiteSign().then((res =>{
      const { code, data } = res
      if( code === "000000" && data) {
        let firstSignTime = data.whiteSignTime
        firstSignTime = dayjs(firstSignTime).format("YYYY-MM-DD")
        this.endSignTime = dayjs(firstSignTime).add(360, 'day').format("YYYY-MM-DD");
        this.whiteSignTime = dayjs().format("YYYY-MM-DD");
        console.log('首次签署日期=======',firstSignTime);
        console.log('再次签署日期=======',this.endSignTime);
        if (this.whiteSignTime < this.endSignTime) window.localStorage.setItem('isSign','1')
      }
    }))
  }
}
